import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg" />
              </span>
              <span className="font-heading font-bold text-base">AllChinaBuy Spreadsheet</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4">
              <a href="#categories" className="hover:text-primary-300 transition-colors">
                {t("categories.title")}
              </a>
            </h4>
            <ul className="grid grid-cols-1 gap-2">
              <li>
                <Link
                  to="/spreadsheet-guide"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                >
                  {t("nav.guide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                >
                  {t("cta.primary")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4">{t("cta.title")}</h4>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              {t("cta.primary")}
              <i className="ri-arrow-right-up-line text-sm" />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            © {new Date().getFullYear()} AllChinaBuy Spreadsheet. {t("footer.rights")}
          </p>
          <p className="text-xs text-background-50/60">allchinabuyspread.pro</p>
        </div>
      </div>
    </footer>
  );
}